import { TreemapNode } from 'utils/components/TreemapChart/treemapData';
import { PortfolioSummaryDataByGroupItem } from '../aggregationByGroup/portfolioSummaryDataByGroup';
import { AggregationField } from '../aggregation/fields/aggregationFieldPortfolio';
import {
    NetGroupName,
    TotalGroupName,
} from '../aggregation/strategies/AggregationStrategy';
import { QuantitiesOptions } from 'utils/components/QuantitiesOptions/QuanitiesOptions';

export function toTreemapData(
    dataByGroup: PortfolioSummaryDataByGroupItem[],
    aggregationField: AggregationField,
    quantities: QuantitiesOptions
): TreemapNode[] {
    const data =
        aggregationField === 'side'
            ? prepareSideData(dataByGroup)
            : dataByGroup;
    return data.map(mapItems(quantities));
}

function mapItems(
    quantities: QuantitiesOptions
): (item: PortfolioSummaryDataByGroupItem) => TreemapNode {
    return (item) => {
        const value = getValue(item, quantities);
        return { name: item.groupName, value };
    };
}

function getValue(
    item: PortfolioSummaryDataByGroupItem,
    quantities: QuantitiesOptions
): number {
    switch (quantities) {
        case 'leaves':
            return item.leavesValueLoc;
        case 'traded':
            return item.tradedValueLoc;
        default:
            return item.orderedValueLoc;
    }
}

function prepareSideData(
    dataByGroup: PortfolioSummaryDataByGroupItem[]
): PortfolioSummaryDataByGroupItem[] {
    /*
     * Remove the "total" and "net" rows that are aggregated for display in the grid
     */
    return dataByGroup.filter(
        (g) => g.groupName !== TotalGroupName && g.groupName !== NetGroupName
    );
}
